import {Colors} from 'appearance'
import {styled} from 'common'
import React from 'react'
import {keyframes} from 'styled-components'

const LoadingDots = ({isLoading}) => {
    if (!isLoading) {
        return null
    }

    return (
        <LoadingWrapper>
            <Dot delay="0s" />
            <Dot delay="0.1s" />
            <Dot delay="0.2s" />
        </LoadingWrapper>
    )
}

export default LoadingDots

const LoadingWrapper = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: center;
    margin-top: 20px;
    height: 0.75rem;
`
const BounceAnimation = keyframes`
  0% { 
    margin-bottom: 0; 
  }

  50% { 
    margin-bottom: 1rem;
  }

  100% { 
    margin-bottom: 0;
  }
`
const Dot = styled.div`
    background-color: ${Colors.TORQUISE};
    border-radius: 50%;
    width: 0.75rem;
    height: 0.75rem;
    margin: 0 0.25rem;
    /*Animation*/
    animation: ${BounceAnimation} 0.5s linear infinite;
    animation-delay: ${(props) => props.delay};
`
